import { useState, useEffect } from 'react';

import { DownOutlined, UpOutlined, RightOutlined } from '@ant-design/icons';
import { cn } from '@lcsc-ui/lib/utils';
import useUserStore from '@lcsc-ui/store/user';
import sendAxios from '@lcsc-ui/utils/request';
import { Popover, message } from 'antd';

import API from '@/apis/index';
import CouponDialog from '@/components/detailPage/components/couponDialog';

const grantLevelNameList = {
  general: '注册会员',
  bronzemedal: '铜牌会员',
  silvermedal: '银牌会员',
  goldmedal: '金牌会员',
  diamondmedal: '钻石会员',
  lmperialcrown: '皇冠会员',
};

export default function ProductDiscountActivity({ data, totalNumber, price }) {
  const projectConfigVO = useUserStore((state) => state.projectConfigVO);
  const [showCouponDialog, setShowCouponDialog] = useState(false);
  const [isShowCoupon, setIsShowCoupon] = useState(false);
  const [loginStatus, setLoginStatus] = useState('');
  const [couponData, setCouponData] = useState({});
  const productRecord = data?.productRecord;
  const [rebateMoney, setRebateMoney] = useState(0);

  useEffect(() => {
    if (data?.isGuidePrice !== 'true') {
      if (!data?.productRebateList) {
        return;
      }
      let rebate = 1;
      let rebateMoney = 0;
      data?.productRebateList?.forEach((val) => {
        if (
          totalNumber >= val.spNumber * productRecord?.theRatio &&
          (totalNumber <= val.epNumber * productRecord?.theRatio || val.epNumber === -1)
        ) {
          rebate = val.rebate;
        }
      });
      rebateMoney = (price * (1 - rebate) * totalNumber).toFixed(2);
      setRebateMoney(rebateMoney);
    }
  }, [totalNumber, price]);

  let sliceNum = 3;
  if (data?.hasPlusCoupon && !data?.isCouponUnavailable && !data?.isShowMroCouponLabel) {
    sliceNum = 2;
  } else if (!(data?.hasPlusCoupon && !data?.isCouponUnavailable) && data?.isShowMroCouponLabel) {
    sliceNum = 2;
  } else if (data?.hasPlusCoupon && !data?.isCouponUnavailable && data?.isShowMroCouponLabel) {
    sliceNum = 1;
  }
  const [productCouponList, setProductCouponList] = useState(data?.productCouponList?.slice(0, sliceNum) || []);
  let isAllEqual = false;
  if (data?.productDiscountList) {
    isAllEqual = data.productDiscountList.some((item) => item.discount !== data.productDiscountList[0].discount);
  }
  const mapLabel = {
    purchase_money: '采购晶',
    point: '积分',
  };

  const closeCoupon = () => {
    setShowCouponDialog(false);
    setCouponData();
  };

  const clickSetCoupon = (type) => {
    setShowCouponDialog(true);
    let couponUrl = `${API.activityCoupon}?productId=${productRecord?.productId}`;
    if (type === 'mro') {
      couponUrl += '&isClickByMroCouponLabel=true';
    }
    if (data?.isOversea) {
      couponUrl = `${API.activityCoupon}?isOversea=1`;
    }
    sendAxios({
      method: 'GET',
      baseURL: 'lcscActivityUrl',
      url: couponUrl,
    })
      .then(({ result }) => {
        setLoginStatus(result?.loginStatus);
        setCouponData(result);
      })
      .catch((error) => {
        if (error?.msg) {
          message.error(`${error?.msg}`);
        }
      });
  };

  const clickOpenCoupon = (isShowCoupon) => {
    setIsShowCoupon(isShowCoupon);
    setProductCouponList(isShowCoupon ? data?.productCouponList : data?.productCouponList?.slice(0, sliceNum));
  };

  // 优惠券
  const CouponTicket = (props) => {
    const { type, text, onClick, theme = 'red' } = props;
    const [hover, setHover] = useState(false);

    return (
      <button
        className={cn(
          'group-1 relative inline-flex h-[18px] cursor-pointer items-center overflow-hidden rounded-[3px] border-[1px] border-solid text-[12px]',
          {
            'border-[#FFD3DA] text-[#FF4960]': theme === 'red',
            'border-[#D2E2EB] text-[#0093E6]': theme === 'blue',
          }
        )}
        onClick={onClick ? onClick : clickSetCoupon}
        onMouseOver={() => setHover(true)}
        onMouseOut={() => setHover(false)}
      >
        <div className={`${hover ? 'invisible' : ''}`}>
          {type && (
            <span
              className={cn('inline-block px-[3px]', {
                'bg-[#FFECEF]': theme === 'red',
                'bg-[#F1F7FC]': theme === 'blue',
              })}
            >
              {type}
            </span>
          )}
          <span className="inline-block px-[6px]">{text}</span>
        </div>
        <div
          className={cn(
            `absolute bottom-0 left-0 right-0 top-0 text-center leading-[16px] ${hover ? 'block' : 'hidden'}`,
            {
              'bg-[#FFECEF]': theme === 'red',
              'bg-[#F1F7FC]': theme === 'blue',
            }
          )}
        >
          立即领券
        </div>
      </button>
    );
  };

  const LabelTicket = ({ children }) => {
    return (
      <li className="inline-block mt-[8px] mr-[6px] text-[12px] bg-[#F1F7FC] text-[#0093E6] border-[1px] border-solid rounded-[4px] h-[18px] leading-[18px] pl-[6px] pr-[6px] cursor-pointer hover:opacity-[0.8]">
        {children}
      </li>
    );
  };

  // 返采购晶标签hover弹窗
  const rebateHover = (
    <>
      <h4 className="text-14px">
        按 <span className="text-[#de3231]">购买数量</span> 进行返采购晶：
      </h4>
      <ul>
        {!data?.isMerge ? (
          (data?.productRebateList || []).map((item) => (
            <li key={item.priceIndex} className="text-center">
              {item.spNumber * productRecord?.theRatio}+：返
              <span className="font-bold text-[#de3231]">{item.rebateCopy}%</span>
            </li>
          ))
        ) : (
          <li className="text-center">
            第1{data?.productRebateList?.length > 1 ? '至' + data?.productRebateList?.length : ''}阶梯：返
            <span className="text-[#de3231]">{data?.rebate}%</span>
          </li>
        )}
      </ul>
      <p>
        当前购买现货商品，发货后预计返采购晶<span className="text-[#de3231]">￥{rebateMoney}</span>，
      </p>
      <p>采购晶可抵扣现货商品金额及兑换礼品</p>
      <a
        className="text-[#0093e6]"
        href={`${projectConfigVO?.lcscActivityUrl}/point/use/info.html?from=dh`}
        data-spm="dh"
      >
        兑换专区
      </a>
    </>
  );

  // 福利兑换活动
  const welfareLabel = (data?.productWelfareList || []).map((welfare, index) => (
    <Popover
      content={
        <>
          <ul className="text-[12px]" data-spm="gm">
            {(welfare.thresholdRedisVOList || []).map((item, index) => (
              <li key={index}>
                {welfare.rebateDimension === 'multiple_order_amount' ? '累计' : '单笔'}
                {welfare.rebateDimension === 'single_order_amount' ||
                (welfare.rebateDimension === 'multiple_order_amount' && item.limitPartakeCount !== 1)
                  ? '每'
                  : ''}
                满 {item.orderAmount} 送<span className="text-[#FF4960]"> {item.rebateAmount} </span>
              </li>
            ))}
            <a
              className="text-[#0093e6] text-[12px]"
              href={welfare?.activityDetailUrl || projectConfigVO?.lcscActivityUrl + '/member/welfare/zone.html'}
              target="_blank"
              data-spm="gz"
            >
              查看具体规则 {'>'}
            </a>
          </ul>
        </>
      }
      placement="bottom"
      key={index}
    >
      <>
        <LabelTicket>
          最高送{welfare.labelHighestAmount}
          {mapLabel[welfare.rebateType]}
        </LabelTicket>
      </>
    </Popover>
  ));

  // 返采购晶标签
  const rebateLabel = data?.isProductRebate && !data.isGuidePrice && data?.rebate > 0 && (
    <Popover content={rebateHover} placement="bottom">
      <>
        <LabelTicket>返{data?.rebate}%</LabelTicket>
      </>
    </Popover>
  );

  // 折扣活动折扣详情hover弹窗
  const discountHover = (
    <ul>
      <li className="text-[12px]">订单数量按照以下：</li>
      {(data?.productDiscountList || []).map((item) => (
        <li key={item.priceIndexCn} className="text-[12px]">
          第{item.priceIndexCn}阶梯<span className="font-bold">{item.discount}</span>折
        </li>
      ))}
    </ul>
  );

  // 优惠活动，折扣标签
  const discountLabel =
    (data?.productDiscountList || []).length > 0 &&
    ((data?.productDiscountList || []).length === 1 ? (
      data?.isPlusDiscount ? (
        <LabelTicket>PLUS专享{Math.round(data?.discountPriceMaxDiscount * 1000) / 100}折</LabelTicket>
      ) : (
        <LabelTicket>{Math.round(data?.discountPriceMaxDiscount * 1000) / 100}折</LabelTicket>
      )
    ) : (
      <Popover content={discountHover} placement="bottom">
        <>
          <LabelTicket>
            {data.isPlusDiscount ? 'PLUS专享' : ''}
            {Math.round(data?.discountPriceMaxDiscount * 1000) / 100}
            {isAllEqual ? '折起' : '折'}
          </LabelTicket>
        </>
      </Popover>
    ));

  // PLUS专享
  const plusItem = data?.hasPlusCoupon && !data?.isCouponUnavailable && (
    <li className="mt-[8px] mr-[6px] leading-[18px]">
      <CouponTicket text="PLUS专享券" />
    </li>
  );

  const mroItem = data?.isShowMroCouponLabel && (
    <li className="mt-[8px] mr-[6px] leading-[18px]">
      <CouponTicket theme="blue" type="运" text="MRO专享" onClick={() => clickSetCoupon('mro')} />
    </li>
  );

  // 满额返券hover弹窗
  const msgItem = (productRecord?.returnCouponDesc || []).map((item) => (
    <li className="mt-[7px]" key={item.message}>
      <span>{item.message}</span>
      {item.url && (
        <a className="text-[#0093E6] underline ml-[10px]" href={item.url} target="_blank" ignore-spm>
          详情 <RightOutlined />
        </a>
      )}
    </li>
  ));

  const checkReturnCoupon = (data) => {
    return Array.isArray(data) ? !data.filter((v) => Object.keys(v).length).length : true;
  };

  // 限购活动 - 商品优惠类型
  const LimitPlusItem = () => {
    const grantLevel = productRecord?.discountBuyLimitProduct?.grantLevel?.split(',');
    let limitPlusStr = '';
    if (grantLevel?.length <= 3) {
      grantLevel?.forEach((item, idx) => {
        limitPlusStr += `${grantLevelNameList[item]}${idx + 1 !== grantLevel?.length ? '、' : ''}`;
      });
    } else {
      const filterKey = [];
      Object.keys(grantLevelNameList).forEach((key) => {
        if (!grantLevel.includes(key)) {
          filterKey.push(key);
        }
      });
      filterKey?.forEach((item, idx) => {
        limitPlusStr += `${grantLevelNameList[item]}${idx + 1 !== filterKey?.length ? '、' : ''}`;
      });
    }
    limitPlusStr = `${limitPlusStr}${grantLevel?.length <= 3 ? '可参与' : '不可参与'}`;
    return (
      <li className="mt-[7px]">
        {productRecord?.discountBuyLimitProduct?.discountMember === 'plus' && <p>仅PLUS会员可参与</p>}
        {grantLevel?.length !== 6 && <p>{limitPlusStr}</p>}
      </li>
    );
  };

  const LimitPlusDesc = () => {
    const grantLevel = productRecord?.discountBuyLimitProduct?.grantLevel?.split(',');
    return grantLevel?.length !== 6 || productRecord?.discountBuyLimitProduct?.discountMember === 'plus' ? (
      <Popover content={<ul>{<LimitPlusItem />}</ul>} placement="bottom">
        <>
          <LabelTicket>
            {productRecord?.discountBuyLimitProduct?.discountType === 'rate' ? '折扣特价' : '优惠特价'}
          </LabelTicket>
        </>
      </Popover>
    ) : (
      <LabelTicket>
        {productRecord?.discountBuyLimitProduct?.discountType === 'rate' ? '折扣特价' : '优惠特价'}
      </LabelTicket>
    );
  };

  const returnCouponDesc = productRecord?.isReturnCoupon && !checkReturnCoupon(productRecord?.returnCouponDesc) && (
    <Popover content={<ul>{msgItem}</ul>} placement="bottom">
      <>
        <LabelTicket>满额返券</LabelTicket>
      </>
    </Popover>
  );

  // 不可用优惠
  const productCouponUnavailable = (
    <ul className="text-[14px] text-[#56657F] flex flex-wrap">
      <li className="mr-[8px] mt-[6px] h-[20px] rounded-[4px] border-[1px] border-solid border-[#FFBEC6] bg-[#FFEDEF] p-[0_2px] text-center text-[12px] text-[#FF4960]">
        不可用商品券
      </li>
    </ul>
  );

  // 优惠券
  const productCoupon = (
    <ul className="text-[14px] text-[#56657F] flex flex-wrap">
      {productCouponList?.map((couponItem, idx) => {
        return (
          <li key={idx} className="mt-[8px] mr-[6px] leading-[18px]">
            {couponItem?.isFreeExpress ? (
              <CouponTicket theme="blue" type="运" text="包邮券" />
            ) : couponItem?.couponType === 'discount' ? (
              <CouponTicket type="折" text={`${couponItem.couponDiscount / 10}折`} />
            ) : couponItem?.couponType === 'product' ? (
              <CouponTicket
                type="商"
                text={
                  couponItem?.couponThresholdMoney
                    ? `满${couponItem?.couponThresholdMoney}-${couponItem?.couponAmount}`
                    : `${couponItem?.couponAmount}元`
                }
              />
            ) : (
              couponItem?.couponType === 'freight' && (
                <CouponTicket theme="blue" type="运" text={`${couponItem?.couponAmount}元`} />
              )
            )}
          </li>
        );
      })}
      {plusItem}
      {mroItem}
      {rebateLabel}
      {welfareLabel}
      {returnCouponDesc}
      {productRecord?.discountBuyLimitProduct?.showTag && <LimitPlusDesc />}
    </ul>
  );

  return (
    <>
      <div className="text-[14px] text-[#56657F] items-center mt-[16px]">
        <h3 className="mr-[28px] text-[14px] text-[#020202] font-bold">优惠活动</h3>
        <div className="flex justify-around">
          <div className="flex-1">{data?.isCouponUnavailable ? productCouponUnavailable : productCoupon}</div>
          {!data?.isCouponUnavailable && data?.productCouponList?.length > 3 && (
            <button
              className="flex text-[12px] items-center cursor-pointer text-[#0093E6] h-[36px]"
              onClick={() => clickOpenCoupon(!isShowCoupon)}
            >
              {isShowCoupon ? (
                <>
                  收起
                  <UpOutlined className="h-[22px] ml-[5px]" />
                </>
              ) : (
                <>
                  展开 <DownOutlined className="h-[22px] ml-[5px]" />
                </>
              )}
            </button>
          )}
        </div>
        {discountLabel}
        {showCouponDialog && (
          <CouponDialog
            isOpen={showCouponDialog}
            couponData={couponData}
            loginStatus={loginStatus}
            clickSetCoupon={clickSetCoupon}
            onClose={closeCoupon}
            isMro={data?.isMro}
          />
        )}
      </div>
    </>
  );
}
